import { render, staticRenderFns } from "./TranslationsEditDatafieldAutocomplete.vue?vue&type=template&id=0e54b566"
import script from "./TranslationsEditDatafieldAutocomplete.vue?vue&type=script&lang=js"
export * from "./TranslationsEditDatafieldAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports